import RequestLocationPrompt from './RequestLocationPrompt';

export default RequestLocationPrompt;
